import { inject, Injectable } from '@angular/core';
import { PermissionsService } from '@/shared/service/Permissions.service';
import { MessageService } from 'primeng/api';
import { HttpService } from '../../../../../Services/http.service';
import { IProgramaPermiso } from '@/interface/general/IProgramaPermiso.interface';
import { BehaviorSubject, Observable } from 'rxjs';
import {
  IConfiguracionSistema,
  IRegistroUsuario,
} from '../../interfaces/consulta-externa-pqrs.interface';
import { IResponseApiGeneric } from '@/interface/general/IResponseApi';
import { TypeResponse } from '@/common/enums/general/TypeResponse';

@Injectable({
  providedIn: 'root',
})
export class RegistroUsuarioService {
  httpService = inject(HttpService);
  messageService = inject(MessageService);
  private permissonService = inject(PermissionsService);
  // CodProgram
  CodProgram!: string;
  private urlGetInitialData = 'PQR/GetInitialDataPQR';
  private urlPostCreate = 'PQR/CreatePticionario';

  // Variables para los permisos
  programasPermisos!: IProgramaPermiso;

  // Opciones multiselect
  TipoDocumentoOptions: any[] = [];
  TipoPqrOptions: any[] = [];
  EmpresaExternoOptions: any[] = [];
  ListaGeneroOptions: any[] = [];
  ListaEstadoOptions: any[] = [];
  //#region Carga inicial

  private dataLoadedSubject = new BehaviorSubject<boolean>(false);
  public dataLoaded$ = this.dataLoadedSubject.asObservable();

  getInitialParameters$(): Observable<
    IResponseApiGeneric<IConfiguracionSistema>
  > {
    return this.httpService.Get<IResponseApiGeneric<IConfiguracionSistema>>(
      this.urlGetInitialData,
    );
  }

  postCreate(data: IRegistroUsuario) {
    return this.httpService.Post<IResponseApiGeneric<string>>(
      data,
      this.urlPostCreate,
    );
  }
  loadInitialData(): void {
    this.getInitialParameters$().subscribe({
      next: (response: IResponseApiGeneric<IConfiguracionSistema>) => {
        console.table(response);
        if (response?.status === TypeResponse.OK && response.data) {
          const data = response.data;

          //#region  Permisos
          if (data.ProgramasPermisosList?.length) {
            this.programasPermisos = data.ProgramasPermisosList[0];
            this.setProgramaPermisos(this.programasPermisos);
          }
          //#endregion
          //#region  Cargar multiselects
          if (data.TipoDocumento?.length) {
            this.TipoDocumentoOptions = data.TipoDocumento.map((p) => ({
              name: p.Descripcion,
              code: p.CodTipoDocumento,
            }));
          }
          if (data.TipoPqr?.length) {
            this.TipoPqrOptions = data.TipoPqr.map((p) => ({
              name: p.Descripcion,
              code: p.CodTipoPqr,
            }));
          }
          if (data.EmpresaExterno?.length) {
            this.EmpresaExternoOptions = data.EmpresaExterno.map((p) => ({
              name: p.Descripcion,
              code: p.CodGlobal,
            }));
          }

          if (data.ListaGenero?.length) {
            this.ListaGeneroOptions = data.ListaGenero.map((p) => ({
              name: p.Descripcion,
              code: p.CodGenero,
            }));
          }
          if (data.ListaEstado?.length) {
            this.ListaEstadoOptions = data.ListaEstado.map((p) => ({
              name: p.Descripcion,
              code: p.CodEstado,
            }));
          }
          //#endregion Fechas
          this.dataLoadedSubject.next(true);
        } else {
          console.warn(
            'La respuesta no tiene status OK o sin Carga Inicial:',
            response,
          );
          this.messageService.add({
            severity: 'warn',
            summary: 'Advertencia',
            detail: 'Sin Permisos en la carga inicial',
            life: 10000,
          });
        }
      },
    });
  }

  setProgramaPermisos(programasPermisos: IProgramaPermiso) {
    // Aqui asignamos los permisos a la Botonera
    console.table(programasPermisos);
    this.permissonService.setActiveProgramAndButtons(
      programasPermisos.CodPrograma,
      ['Grabar'],
    );

    this.CodProgram = programasPermisos.CodPrograma;
    this.permissonService.setPermissionsForProgram(programasPermisos);
  }

  //#endregion
}
